export class ScrollHelper {
	static scrollTo(selector = 'body', margin: number | string = 0): void {
		const element = document.querySelector(selector)?.getBoundingClientRect()?.top;
		element && window.scrollTo({ top: element + (isNaN(+margin) ? +margin : 0), behavior: 'smooth' });
	}
}
